import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EmailSendSkip = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M11.4375 15.9375C11.4375 17.131 11.9116 18.2756 12.7555 19.1195C13.5994 19.9634 14.744 20.4375 15.9375 20.4375C17.131 20.4375 18.2756 19.9634 19.1195 19.1195C19.9634 18.2756 20.4375 17.131 20.4375 15.9375C20.4375 14.744 19.9634 13.5994 19.1195 12.7555C18.2756 11.9116 17.131 11.4375 15.9375 11.4375C14.744 11.4375 13.5994 11.9116 12.7555 12.7555C11.9116 13.5994 11.4375 14.744 11.4375 15.9375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.625 14.25L14.25 17.625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 14.25L17.625 17.625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.1875 14.8125H4.6875C4.38913 14.8125 4.10298 14.694 3.892 14.483C3.68103 14.272 3.5625 13.9859 3.5625 13.6875V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H18.1875C18.4859 3.5625 18.772 3.68103 18.983 3.892C19.194 4.10298 19.3125 4.38913 19.3125 4.6875V9.75"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0581 3.9751L12.9502 8.6731C12.5164 9.00674 11.9846 9.18764 11.4374 9.18764C10.8902 9.18764 10.3584 9.00674 9.92465 8.6731L3.81665 3.9751"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
